const searchEnvironmentSelection = {
  'Stage 3': 'stage3',
  'Stage 4': 'stage4',
  'Pre-Live': 'pre',
  Production: 'prod',
};
export default searchEnvironmentSelection;
